import { Component, OnInit, Input } from '@angular/core';
import { VisitasService } from '../../services/visitas.service';
import { Visita } from '../../models/visita';
import { Observable, } from 'rxjs';
import { TasacionArchivo} from '../../models/TasacionArchivo';
import { map } from 'rxjs/operators';
import { TasacionArchivoValues } from '../../models/enums';
import { Direccion } from '../../models/direccion';
import { FormGroup} from '@angular/forms';

import { FormControl, FormArray, Validators} from '@angular/forms';

@Component({
  selector: 'app-visitas-view',
  templateUrl: './visitas-view.component.html',
  styleUrls: ['./visitas-view.component.scss']
})
export class VisitasViewComponent implements OnInit {
  
  @Input() id: number;

  visita: Visita = ({ idTasacion: null, version: null, fechaVisita: null, calle: null, numero: null, bloque: null, altura: null, letra: null, idTipoInmueble: null, ocupacionInmueble: null, superficieUtil: null, superficieAdoptada: null, superficieCatastral: null, superficieConstruida: null, tieneTerrza: null, superficieUtilTerraza: null, tipoTerraza: null, tieneCalefaccion: null, tipoCalefaccion: null, tieneAireAcondicionado: null, numEstanciasAireAcond: null, tieneTrastero: null, superficieUtilTrastero: null, tieneGaraje: null, tipoGaraje: null, fechaVisitaFinalizada: null });

  // visita = {calle:null, numero:null, bloque:null, altura:null, letra:null, fechaVisita:null};
  version = 1;

  ficherosVisitaList: Observable<TasacionArchivo[]>;
  
  tipoInmueble: any[];
  selectOcupacion: any[];
  selectTerraza: any[];
  selectCalefaccion: any[];
  selectGaraje: any[];

  listRooms = true;
  idRoom: number;


  /* ------------------------ */

  /*
  step: string;
  nav_visible: boolean;
  eventSwipe = '';
  stepVal: number;
  maxstep = 7;
  minstep = 1;
  tipoInmueble: Map<string, string>;
  selectOcupacion: Map<string, string>;
  selectTerraza: Map<string, string>;
  selectCalefaccion: Map<string, string>;
  selectGaraje: Map<string, string>;
  Titulo = 'Fotos';
  needRefreshArchivos = false;
  ficherosVisitaList: Observable<TasacionArchivo[]>;
  estancia?: number;
  selectMap: boolean;
  form: FormGroup;
  */

  /* ------------------------ */

  constructor(private visitaService: VisitasService) { }

  ngOnInit() {
    // this.selectMap = false;
    this.cargarSelect();
    this.loadData();
    // this.nav_visible = true;
  }

  loadData() {
    // retrieve the ID from the 'id' parameter
    if (this.id) {
      this.visitaService.get(this.id, 1).subscribe(result =>
        {
          this.visita = result;
          console.log("---------");
          console.log(this.visita);
          console.log("---------");
        }, error => console.error(error));
    }
  }

  private cargarSelect() {

    this.visitaService.getTiposInmueble()
      .subscribe( (data: any) => {
        this.tipoInmueble = data;
      });

    this.visitaService.getSelectOcupacion()
      .subscribe( (data: any) => {
        this.selectOcupacion = data;
      });

    this.visitaService.getTipoTerraza()
      .subscribe((data: any) => {
        this.selectTerraza = data;
      });

    this.visitaService.getTipoCalefaccion()
      .subscribe((data: any) => {
        this.selectCalefaccion = data;
      });

    this.visitaService.getTipoGaraje()
      .subscribe((data: any) => {
        this.selectGaraje = data;
      });
  }

  ShowRoom(idRoom) {
    this.idRoom = idRoom;
    this.listRooms = false;
  }


  /* ------------------------------------------------------------------------ */

  /*

  navegar(step) {
    this.step = step;
    this.closeNav();
    this.nav_visible = true;
  }

  closeNav() {
    document.getElementById('mySidebar').style.width = '0';
    document.getElementById('main').style.marginLeft = '0';
    this.nav_visible = true;
  }

  onSwipe(evt) {
    const x = Math.abs(evt.deltaX) > 40 ? (evt.deltaX > 0 ? 'right' : 'left') : '';
    const y = Math.abs(evt.deltaY) > 40 ? (evt.deltaY > 0 ? 'down' : 'up') : '';

    this.eventSwipe = `${x}${y}`;

    this.stepVal = +this.step.replace('step', '').replace('Estancia', '');
    if (this.eventSwipe === 'right')
    {
      if (this.step.includes('Estancia'))
        this.stepVal = 6;
      else
        this.stepVal--;
    }
    else if (this.eventSwipe  === 'left')
    {
      this.stepVal++;
    }

    if (this.stepVal > this.maxstep ) { this.stepVal = this.maxstep; }
    if (this.stepVal < this.minstep ) { this.stepVal = this.minstep; }

    this.step = `step${this.stepVal}`;
  }

  openNav() {
    if(this.nav_visible)
    {
      document.getElementById('mySidebar').style.width = '250px';
      document.getElementById('main').style.marginLeft = '250px';
      this.nav_visible = false;
    }
    else
    {
        this.closeNav();
    }
  }

  private cargarSelect()
  {
    this.visitaService.getTiposInmueble().subscribe((res: Map<string, string>) => this.tipoInmueble = res);
    this.visitaService.getSelectOcupacion().subscribe((res: Map<string, string>) => this.selectOcupacion = res);
    this.visitaService.getTipoTerraza().subscribe((res: Map<string, string>) => this.selectTerraza = res);
    this.visitaService.getTipoCalefaccion().subscribe((res: Map<string, string>) => this.selectCalefaccion = res);
    this.visitaService.getTipoGaraje().subscribe((res: Map<string, string>) => this.selectGaraje = res);
  }

  refreshArchivos()
  {
    if (this.needRefreshArchivos)
    {
      if (this.id !== undefined)
      {
        const svcGeneric = this.visitaService.getFicherosVisita(this.visita.idTasacion, this.version, -1);
        this.ficherosVisitaList = svcGeneric.pipe(map( (d) =>
          {
            return d.filter( d2 => d2.tipoArchivo === TasacionArchivoValues.Fotos);
          }
        ));
        this.needRefreshArchivos = false;
      }
    }
  }

  onFileUploaded(event)
  {
    this.needRefreshArchivos = true;
    this.refreshArchivos();
  }

  getDirection(direccion: Promise<Direccion>)
  {
    direccion.then(value => {
      this.form.patchValue({calle: value.calle});
      this.form.patchValue({numero: value.numero});

    });
  }

  */

  /* ------------------------------------------------------------------------ */


}
